import { render, staticRenderFns } from "./CredentialInvite.vue?vue&type=template&id=66b108f3&"
import script from "./CredentialInvite.vue?vue&type=script&lang=js&"
export * from "./CredentialInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput})
